import React from 'react';
import styled from 'styled-components';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { themeMode, radius, variant, color } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
import { useModalContext } from './ModalContext.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const modalScrollBehavior = variant({
  prop: "scrollBehavior",
  variants: {
    inside: { overflow: "auto" }
  }
});
const StyledModalContent = styled(Box)`
    flex: 1 1 auto;
    background-color: ${themeMode({
  dark: color("neutral.900"),
  light: color("neutral.0")
})};

    ${modalScrollBehavior};

    &:first-child {
        border-top-left-radius: ${radius("base")};
        border-top-right-radius: ${radius("base")};
    }

    &:last-child {
        border-bottom-left-radius: ${radius("base")};
        border-bottom-right-radius: ${radius("base")};
    }
`;
const ModalContent = forwardRef((_a, ref) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  const { scrollBehavior } = useModalContext();
  return /* @__PURE__ */ React.createElement(StyledModalContent, __spreadValues({
    ref,
    scrollBehavior
  }, props), children);
});
ModalContent.displayName = "Modal.Content";

export { ModalContent };
//# sourceMappingURL=ModalContent.es.js.map
